module.exports = __webpack_public_path__ + "static/media/MHRP75N0001.76c7cba1.svg";